import { Result } from "./result";
import { runAction, TransactionScheduler } from "./transaction";
export class DisposedReactionError extends Error {
    constructor() {
        super("Disposed reaction");
    }
}
/**
 * Side effect
 */
export class StateReaction {
    constructor(observable) {
        this.observable = observable;
        this.scheduler = new TransactionScheduler(() => {
            this.observable.calc();
            if (this.observable.result instanceof Result.Error) {
                console.error(this.observable.result.error);
            }
        });
        this.subscription = observable.subscribe({
            changed() { },
            dirty: () => this.scheduler.schedule(),
        });
        this.scheduler.schedule();
    }
    /**
     * Get the current value
     */
    get value() {
        if (!this.subscription) {
            throw new DisposedReactionError();
        }
        return this.observable.result.getValue();
    }
    /**
     * Stop tracking
     */
    dispose() {
        runAction(() => {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        });
    }
}
/**
 * Store the observable
 */
export function store(observable) {
    return runAction(() => new StateReaction(observable));
}
/**
 * Store the observable
 */
export function storeState(state) {
    return store(state.observable);
}
//# sourceMappingURL=store.js.map